const o = {
  black: "#000",
  white: "#fff"
}, c = o;
export {
  c as default
};
//# sourceMappingURL=common.mjs.map
